import styled, { css } from 'styled-components'


const BackgroundDark = styled.div`
width:100vw;
height: 100vh;
background-color: #F9FBFC;
`

export default BackgroundDark